import "./App.css"
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import MuiTabs from './PortfolioContainer/Navbar/Mui-tabs';
import MuiDrawer from './PortfolioContainer/Navbar/Mui-drawer'
import Footer from './PortfolioContainer/Footer/Footer';


function App() {
      
  const theme = useTheme();
  console.log(theme)
  const isMatch = useMediaQuery(theme.breakpoints.down('md'));
  console.log(isMatch)
  return (
    <div className="App">
    {
      isMatch ? (
        <MuiDrawer />
      ) : (
        <MuiTabs />
      )
    }
      <Footer />
    </div>
  );
}

export default App;